module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_AF.b3106961.txt";